import React from 'react';
import { Maximize, Minimize } from 'lucide-react';
import { useFullscreen } from '../hooks/useFullscreen';

interface FullscreenButtonProps {
    className?: string;
    showLabel?: boolean;
    enterFullscreenText?: string;
    exitFullscreenText?: string;
}

export default function FullscreenButton({ 
    className = '', 
    showLabel = false,
    enterFullscreenText = 'Enter Fullscreen',
    exitFullscreenText = 'Exit Fullscreen'
}: FullscreenButtonProps) {
    const { isFullscreen, isSupported, toggle } = useFullscreen();

    if (!isSupported) {
        return null; // Don't render if fullscreen is not supported
    }

    const handleClick = async () => {
        await toggle();
    };

    return (
        <div className="w-full">
            <button 
                onClick={handleClick}
                className={`
                    py-2 px-3 
                    mx-auto 
                    min-w-16 max-w-full w-full 
                    font-medium 
                    transition-all duration-200 
                    rounded-xl 
                    border border-neutral-950
                    bg-transparent 
                    flex items-center justify-center gap-2 
                    ${className} 
                `}
            >
                {isFullscreen ? (
                    <>
                        <Minimize size={16} />
                        {showLabel && <span>{exitFullscreenText}</span>}
                    </>
                ) : (
                    <>
                        <Maximize size={16} />
                        {showLabel && <span>{enterFullscreenText}</span>}
                    </>
                )}
            </button>
        </div>
    );
} 